'use strict';

import React, { Component, useDebugValue, useState, useEffect, useCallback, useRef, useContext } from 'react';
import { render } from 'react-dom';
import { AgGridReact } from '@ag-grid-community/react';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { MenuModule } from '@ag-grid-enterprise/menu';
// import Consignmentforceclose from '../m';
import DrawMap from '../common/drawmap';
import CommentActions from "../layouts/commentsComponent";
import ForceCloseSideBar from "./forceclosuresidebarcomponent";
import { AllModules, GridOptionsWrapper } from '@ag-grid-enterprise/all-modules';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import MarkDeliver from "../layouts/markDeliveredButton.js";
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import ConsignmentActions from '../manage/ConsignmentActionsComponent';
import CountUp from 'react-countup';
import SweetAlert from 'react-bootstrap-sweetalert';
import CSVFileValidator from 'csv-file-validator';
import { findTransporterByCode } from "./sobTransporterLookup";
import Consignmentforceclose from '../manage/consignmentforceclose';
import UpdateButton from "./updatelmstates";
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import CellGraphComponent from './cellGraphComponent';
import $ from 'jquery';
import ColumnGroup from './columngroupComponent';
import { getDDMMYYYY, getHyphenYYYYMMDD, getHyphenDDMMMYYYYHHMM, getHyphenDDMMMYYYY, getHyphenYYYYMMDDHHMMSS, getHyphenDDMMYYYYHHMMSS, getDDMMYYYYHHMMSS, getYYYYMMDD, getYYYYMMDDHHMMSS } from '../common/utils';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { HardwareDesktopWindows } from 'material-ui/svg-icons';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from "@fullcalendar/timegrid";
import Showlmvalue from "./showlmvalue";
import { verifyext, verifycsvdata } from "../common/verifyext";
import XLSX from "xlsx/dist/xlsx.full.min.js";
import { LoadingPortContext, resolvePageAccess } from '../../context/LoadingPortContext';
// const $ = window.$;
window.jQuery = $;
window.$ = $;
var redirectURL = require('../redirectURL');
var moment = require('moment');
var filecontent = "";
var googleAnalytics = require("../common/googleanalytics");
var CELL_DIMENSION_SIZE = 90;

// The "Weekly SOB Reset on" / "Daily SOB synced on" labels read fields an older load-share batch
// may not carry at all. moment.parseZone(undefined) returns the CURRENT date-time, so a missing
// value used to render as TODAY - that is what made the reset date read 13-Oct @ 02:33 PM (the
// page render time) when the accumulation cycle had actually started on the 8th.
// Return "" for anything unusable and let the caller hide the line.
function formatSobStamp(value, withTime) {
    if (value === undefined || value === null || value === "") {
        return "";
    }
    var m = moment.parseZone(value);
    if (!m.isValid()) {
        return "";
    }
    return m.format(withTime ? 'DD-MMM-YYYY @ hh:mm A' : 'DD-MMM-YYYY');
}





export default class LmLoadShare extends Component {
    static contextType = LoadingPortContext;
    constructor(props, context) {
        super(props, context);
        this._lastLoadingPortCode = context ? context.loading_port_code : null;
        this.state = {
            modules: AllModules,
            defaultColDef: {
                sortable: true,
                filter: true,
                editable: true,
            },
            eventAction: null,
            show: false,
            show1: false,
            frameworkComponents: {
                consignmentforceclose: Consignmentforceclose,
                consignmentActions: ConsignmentActions,
                UpdateButton: UpdateButton,
                MarkDeliver: MarkDeliver,
                commentActions: CommentActions,
                Showlmvalue: Showlmvalue
            },
            modified_by: "",
            basicTitle: '',
            basicTitle1: '',
            reasonforceclose: "",
            bulkslide: "",
            file: "",
            uploadFile: "",
            basicType: "default",
            basicType1: "default",
            loadshow: 'show-n',
            forceCloseRowNode: "",
            forceclosedata: "",
            csvcontent: "",
            sliderForceCloseTranslate: "",
            overly: '',
            rowData: [],
            bulkslide: "",
            showDiv: "",
            uploadDivWidth: "",
            mapinfo: "",
            dealer: "",
            sliderCommentTranslate: "",
            commentsRowData: "",
            consignment_code: "",
            sliderRouteTranslate: "",
            maptruckno: "",
            routeTruck: "",
            rownode: "",
            googelRoutes: "",
            file: "",
            rowSelection: 'multiple',
            sliderForceCloseTranslate: "",
            maptruckno: "",
            rowModelhighchartoptionsType: 'enterprise',
            rowGroupPanelShow: 'always',
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: "agTotalAndFilteredRowCountComponent",
                        align: "left"
                    },
                    {
                        statusPanel: "agTotalRowCountComponent",
                        align: "center"
                    },
                    { statusPanel: "agFilteredRowCountComponent" },
                    { statusPanel: "agSelectedRowCountComponent" },
                    { statusPanel: "agAggregationComponent" }
                ]
            },
            paginationPageSize: 200,
            geofencelist: [],
            geoFenceData: "",
            sideBar: {
                toolPanels: [
                    {
                        id: "columns",
                        labelDefault: "Columns",
                        labelKey: "columns",
                        iconKey: "columns",
                        toolPanel: "agColumnsToolPanel"
                    },
                    {
                        id: "filters",
                        labelDefault: "Filters",
                        labelKey: "filters",
                        iconKey: "filter",
                        toolPanel: "agFiltersToolPanel"
                    }
                ]
            },
            animateRows: true,
            dept_code: "",
            pagetitle: "",
            markDeliverRowNode: "",
            markDeliverData: "",
            sliderMarkDeliverTranslate: "",
            csvData: 0,
            overly: "show-m",
            loadshow: "show-m",
            trnsportersList: [],
            statesList: [],
            vehicleList: [],
            showCalendar: "show-m",
            showGridData: "show-m",
            transdata: [],
            transactionId: "",
            pinnedRegionBottomRowData: [],
            zonesList: [],
            zoneStates: [],
            sliderType: 1,
            zonewise: "activet",
            statewise: "",
            dataType: 0,
            generatedDate: "",
            generatedType: "",
            resetDate: "",
            comp_code: "",
            lpNames: [],
            loading_port_code: "",
            sobCount: 0, hubActive: "",
            data_type: 1,
            regularActive: "activet",
            truckActive: "",
            courierActive: "",
            //components : {datepicker:getDatePicker()}
        }
        this.changeFileHandler = this.changeFileHandler.bind(this);
        this.uploadBulkFormHandler = this.uploadBulkFormHandler.bind(this);
        this.onCellClicked = this.onCellClicked.bind(this)
        this.onLoadShowData = this.onLoadShowData.bind(this);
        this.createColumns = this.createColumns.bind(this);
        this.createRows = this.createRows.bind(this);
        this.onClickResetData = this.onClickResetData.bind(this);
        this.checkFileData = this.checkFileData.bind(this);
    }

    componentDidMount() {
        loadDateTimeScript();
        // MASTER SCREEN ONLY (client, 2026-10-14). The route keeps its :eventname segment so the
        // menu entry ("/lmloadshare/default") and old links still resolve, but a transaction id in
        // it is ignored - SOB is no longer run from here. It runs from the plan's SOB panel, which
        // shows today's trucks and the approved-vs-actual share together.
        this.setState({
            transactionId: "",
            dataType: 0
        });
        this.pageAccess();
    }
    async pageAccess() {
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m',
        })
        var currentUrl = "/lmloadshare/default";
        var resolved = await resolvePageAccess(currentUrl, this.context);
        if (!resolved) {
            this.setState({ loadshow: 'show-n', overly: 'show-n' });
            return;
        }
        this._lastLoadingPortCode = resolved.loading_port_code;
        this.setState({
            pageAccess: resolved.pageAccess,
            loading_port_code: resolved.loading_port_code,
            comp_code: resolved.comp_code,
            lpNames: resolved.lpNames,
            loadshow: 'show-n',
            overly: 'show-n',
        });
        await this.onLoadShowData();
    }
    onLoadShowData = async () => {
        this.setState({
            overly: "show-m",
            loadshow: "show-m",
        })
        var dataType = this.state.dataType;
        var data_type = this.state.data_type;
        var loading_port_code = this.state.loading_port_code;
        var params = {
            loading_port_code: loading_port_code,
            data_type: data_type, 
            is_air_courier: this.state.airCourierActive == "activet" ? true : false,
            collection: this.state.airCourierActive == "activet" ? "lmaircourierloadshare"
                : this.state.truckActive == "activet" ? "lmcourierloadshare"
                    : ""
        }
        console.log(dataType, "dataType")
        // The approved-SOB total used to be fetched here only to gate the "Load Process Run SOB"
        // button of the old transaction-scoped path. That button is gone, and the fetch with it -
        // it also REASSIGNED `params`, dropping `collection` / `is_air_courier` from the courier
        // call that follows.
        if (dataType == 0) {
            if (this.state.airCourierActive != "activet" && this.state.truckActive != "activet") {
                await redirectURL.post("/lmconsignees/getLoadShare", params).then((response) => {
                    //console.log(response.data,"respo");
                    var generatedDate = "";
                    var generatedType = "";
                    var resetDate = "";
                    if (response.data.length > 0) {
                        // keep "" rather than undefined - see formatSobStamp
                        resetDate = response.data[0].last_reset_on || "";
                        generatedDate = response.data[0].created_date || "";
                        generatedType = response.data[0].generated_type;
                        console.log(resetDate, generatedDate, "dates")
                    }
                    this.setState({
                        transdata: response.data,
                        dataType: dataType,
                        generatedDate: generatedDate,
                        generatedType: generatedType,
                        resetDate: resetDate,
                    })
                }).catch((e) => {
                    console.log(e);
                })
            } else{
                await redirectURL.post("/lmconsignees/getCourierLoadShare", params).then((response) => {
                    //console.log(response.data,"respo");
                    var generatedDate = "";
                    var generatedType = "";
                    var resetDate = "";
                    if (response.data.length > 0) {
                        // keep "" rather than undefined - see formatSobStamp
                        resetDate = response.data[0].last_reset_on || "";
                        generatedDate = response.data[0].created_date || "";
                        generatedType = response.data[0].generated_type;
                        console.log(resetDate, generatedDate, "dates")
                    }
                    this.setState({
                        transdata: response.data,
                        dataType: dataType,
                        generatedDate: generatedDate,
                        generatedType: generatedType,
                        resetDate: resetDate,
                    })
                }).catch((e) => {
                    console.log(e);
                })
            }

            await redirectURL.post("/lmconsignees/getLmSobUniqueZones", params).then((response) => {
                var statesList = response.data;
                this.setState({
                    statesList: statesList,
                })
            }).catch((e) => {
                console.log(e);
            })
        }
        else {
            if(this.state.airCourierActive != "activet" && this.state.truckActive != "activet"){
            await redirectURL.post("/lmconsignees/getStatesLoadShare", params).then((response) => {
                console.log(response.data, "statewise");
                this.setState({
                    transdata: response.data,
                    dataType: dataType
                })
            }).catch((e) => {
                console.log(e);
            })
        } else {
            await redirectURL.post("/lmconsignees/getStatesCourierLoadShare", params).then((response) => {
                console.log(response.data, "statewise");
                this.setState({
                    transdata: response.data,
                    dataType: dataType
                })
            }).catch((e) => {
                console.log(e);
            })
        }

            await redirectURL.post("/lmconsignees/getLmSobUniqueStates", params).then((response) => {
                var statesList = response.data;
                this.setState({
                    statesList: statesList,
                })
            }).catch((e) => {
                console.log(e);
            })
        }

        await redirectURL.post('/lmconsignees/prtUniqueTransportersListWithNames', { ...params, air_courier_transporter: this.state.airCourierActive == "activet" ? 1 : 0 })
            .then((response) => {
                //console.log(response.data);
                var transporters = response.data;
                this.setState({
                    trnsportersList: transporters,
                })
            })
            .catch(function (error) {
                console.log(error)
            });

        await this.createColumns();
        await this.createRows();
    }
    createColumns() {

        var transporters = this.state.trnsportersList;
        var states = this.state.statesList
        var columns = []
        columns.push({
            headerName: "Transporter Name",
            field: "transporter_name",
            width: 230,
            resize: true,
            filter: true,
            editable: false, pinned: "left"
        })
        columns.push({
            headerName: "Transporter Code",
            field: "transporter_code",
            width: 180,
            resize: true,
            filter: true,
            editable: false, pinned: "left",
            cellStyle: { borderLeft: '1px solid #ccc' }
        })
        states.map((trans) => {
            //console.log("trans ", trans)
            var defs = {}
            states.map((ste) => {
                //  console.log("ste ", ste)

                var ss = trans
                defs.headerName = `${trans} ( % )`;
                defs.field = ss;
                var dataType = this.state.dataType;
                if (dataType == 0) {
                    defs.width = 150;
                }
                else {
                    defs.width = 150;
                }
                defs.editable = false;
                defs.cellStyle = { borderLeft: '1px solid #ccc' };
                defs.cellRendererSelector = function (params) {

                    var rendComponent = {
                        component: 'Showlmvalue'
                    };
                    return rendComponent
                }
            })

            columns.push(defs)
        })
        this.setState({
            columnwithDefs: columns,
            overly: "show-n",
            loadshow: "show-n",
        })
    }
    createRows() {
        var statesList = this.state.statesList;
        var transporters = this.state.trnsportersList;
        var transdata = this.state.transdata;
        var rowdefs = []
        var totalCnt = 0
        transporters.map((ste) => {
            var rows = {}
            rows.transporter_name = ste.transporter_name;
            rows.transporter_code = ste.transporter_code;
            var rowcnt = 0
            if (transdata.length > 0) {
                var transportername = groupBy(transdata, rdata => rdata.transporter_code);
                transportername.forEach((trans, transkey) => {
                    trans.map((t) => {
                        rows["zone"] = transkey;
                        if (t.transporter_code == ste.transporter_code) {
                            // if(Number.isInteger(t.load)  == false)
                            // {
                            //     rows[t.zone] = t.load.toFixed(2);
                            // }
                            // else
                            // {
                            rows[t.zone] = t.load
                            //}
                            rowcnt = rowcnt + parseFloat(t.load)
                        }
                    })

                })
            }
            var totalRowCnt = rowcnt;
            totalCnt = totalCnt + parseInt(rowcnt);
            if (Number.isInteger(totalRowCnt) == false) {
                var totalRowCnt = rowcnt.toFixed(2);
            }
            rowdefs.push(rows)
        })
        var pinnedBottomRowData = {}
        var temp = {};
        if (rowdefs.length > 0) {
            var gridkeys = Object.keys(rowdefs[0]);
            gridkeys.map(function (e) {
                temp[e] = 0
            })
        }
        else {
            var gridkeys = [];
        }
        var bhncnt = 0;
        gridkeys = gridkeys.filter(function (e) { return e != "transporter_name" && e != "transporter_code" && e != "zone" })
        rowdefs.map(function (e, index) {
            gridkeys.map(function (k) {
                temp[k] = temp[k] + parseFloat(e[k]);
            })
        })
        temp['Total'] = totalCnt;
        temp['transporter_name'] = "";
        temp['transporter_code'] = "Total ( % )";
        // var zoneDetails = {};
        // zoneDetails.transporter_name = "";
        // zoneDetails.transporter_code = "";
        // statesList.map(function(s){
        //     zoneDetails[s] = "View States";
        // });
        // rowdefs.push(zoneDetails)
        this.setState({
            rowData: rowdefs,
            pinnedRegionBottomRowData: [temp],

        })
    }
    onGridReady = params => {
        this.gridApi = params.api;
        //console.log("Grid is: ", params);
        this.gridColumnApi = params.columnApi;
        var sort = [
            {
                colId: 'transporter_name',
                sort: 'asc',
            },
        ];
        this.gridApi.setSortModel(sort);
    };
    onGridState = () => {
        //console.log(this.gridApi);

        /*Get  Current Columns State and Store in this.colState */
        this.colState = this.gridColumnApi.getColumnState();

        /*Get Current RowGroup Columns State and Store in this.rowGroupState */
        this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

        /*Get Current Pivot Columns State and Store in this.pivotColumns, 
        * User should enable the Pivot mode.*/
        this.pivotColumns = this.gridColumnApi.getPivotColumns();

        /*Get Current Filter State and Store in window.filterState */
        window.filterState = this.gridApi.getFilterModel();
        this.gridApi.setFilterModel(window.filterState);
    }



    closeAlert = () => {
        this.setState({
            show: false
        });
    }

    closeAlert1 = () => {
        this.setState({
            show1: false
        });
        window.location.href = "/lmshareofbusiness";
    }

    onCellClicked(e) {
        //console.log(e);
        if (e.value == "View States") {
            var zone = e.colDef.field;
            if (zone != undefined && zone != '') {
                var zonesList = this.state.zonesList;
                var zoneStates = zonesList.filter(function (e) { return e.zone == zone });
                console.log(zonesList, "zonesList")
                console.log(zoneStates, "zoneStates")
                $(".subH").html(zone + " States");
                this.setState({
                    sliderType: 2,
                    zoneStates: zoneStates,
                    overly: "show-m",
                    bulkslide: "slider-translate"
                })
            }
        }
    }

    // onCellUpdateData = (params) => {
    //     console.log("Params ", params)
    //     var colData = params.data;
    //     var objects = Object.keys(colData);
    //     var rowTotal = 0;
    //     objects.map(function(e){
    //         if(parseInt(params.data[e]).toString() != "NaN")
    //         {
    //             rowTotal = parseInt(rowTotal)+parseInt(params.data[e]); 
    //         }
    //     })
    //     objects.map(function(f,index){
    //         if(f == "total")
    //         {
    //             var currentField = params.data.total;
    //             console.log(currentField,index)
    //             params.data[currentField] = rowTotal;
    //         }
    //     })
    // }

    onClickHideAll() {
        this.setState({
            loadshow: 'show-n',
            overly: 'show-n',
            zoneStates: [],
            sliderType: 1,
            bulkslide: "",

        });

    }
    updateLmStates(params) {
        //console.log(params);
        if (params.transporter_name != '' && params.transporter_name != undefined && params.state != '' && params.state != undefined && params.sob != '' && params.sob != undefined) {
            params.data_type = this.state.data_type;
            redirectURL.post("/lmconsignees/savelmshareofbusiness", params).then((response) => {
                console.log(response);
                if (response.data.message == "Success") {
                    this.setState({
                        basicTitle: "Updated Successfully.",
                        basicType: "success",
                        show: true
                    })
                    window.location.reload();
                }
                else {
                    this.setState({
                        basicTitle: "Failed to update.",
                        basicType: "warning",
                        show: true
                    })
                }
            })
        }
        else {
            this.setState({
                basicTitle: "Fields Should not be Empty.",
                basicType: "warning",
                show: true
            })
        }
    }
    addNewRow() {
        // console.log(this.gridApi);
        this.gridApi.insertItemsAtIndex(0, [{ transporter_name: "", state: "", sob: "" }])
        // this.gridApi.updateRowData({add:[{holiday_date:"",holiday_name:""}]});
    }
    showGrid() {
        this.setState({
            showCalendar: "show-n",
            showGridData: "show-m"
        })
    }
    onClickDataExport() {
        var params = {
            fileName: "load_share.csv"
        };
        this.gridApi.exportDataAsCsv(params);
    }
    showBulkUpload() {
        $(".subH").html("Bulk Upload");
        this.setState({
            overly: "show-m",
            bulkslide: "slider-translate"
        })
    }
    resetUpload = () => {
        this.setState({
            bulkslide: '',
            zoneStates: [],
            sliderType: 1,
            overly: 'show-n',
            file: ''
        });
        document.getElementById("upform").reset();
    }
    changeFileHandler = async (e) => {
        var dt = '';
        const config = {
            headers: [
                {
                    name: 'Transporter Name',
                    inputName: 'transporter_name',
                    required: true,
                    requiredError: function (headerName, rowNumber, columnNumber) {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
                {
                    name: 'Transporter Code',
                    inputName: 'transporter_code',
                    required: true,
                    requiredError: function (headerName, rowNumber, columnNumber) {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
                {
                    name: 'Zone',
                    inputName: 'zone',
                    required: false,
                    requiredError: function (headerName, rowNumber, columnNumber) {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
                {
                    name: 'State',
                    inputName: 'state',
                    required: false,
                    requiredError: function (headerName, rowNumber, columnNumber) {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
                {
                    name: 'Load Share',
                    inputName: 'sob',
                    required: false,
                    requiredError: function (headerName, rowNumber, columnNumber) {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
            ]
        }
        var data = CSVFileValidator(e.target.files[0], config)
            .then((csvData) => {
                this.setState({
                    csvData: csvData.data
                });
                console.log(csvData.data);
            })
            .catch(err => { })
        // console.log("e.target.files[0]",e.target.result);

        var out = new Promise(function (reject, resolve) {
            var reader = new FileReader();
            reader.onload = async function (e) {
                var contents = await e.target.result;
                resolve(contents);
            };
            var tt = reader.readAsText(e.target.files[0]);
        });
        this.setState({
            file: e.target.files[0]
        });
        // console.log("e.target.files[0].type ", e.target.files[0]);

        if (e.target.files[0].type == '' || e.target.files[0].type == 'text/csv' || e.target.files[0].type == 'application/vnd.ms-excel') {
            // console.log(fileData);
            // console.log(typeof(fileData))

        }
        else {
            e.target.value = null;
            this.setState({
                uploadFile: '',
                show: true,
                basicType: 'danger',
                basicTitle: 'Please upload file having extensions .csv only.',
            });
        }

    }

    checkFileData() {

        var vdata = verifycsvdata(JSON.stringify(this.state.csvData));
        //console.log("verifycsvdata ", vdata)
        if (vdata == 0) {
            this.setState({
                csvData: '',
                show: true,
                basicType: 'danger',
                basicTitle: 'File contains invalid data',
                uploadFile: '',
                file: ""
            });
        }
    }
    uploadBulkFormHandler(event) {
        event.preventDefault();
        var fileData = this.state.csvData;
        var flag = 0;
        console.log(fileData, "fileData");
        var vdata = verifycsvdata(JSON.stringify(this.state.csvData));
        console.log("verifycsvdata ", vdata)
        if (vdata == true) {
            this.setState({
                csvData: '',
                show: true,
                basicType: 'danger',
                basicTitle: 'File contains invalid data',
                uploadFile: '',
                file: ""
            });
        }
        else {
            if (flag == 0) {
                if (fileData.length > 0) {
                    var reqParams = {
                        loading_port_code: this.state.loading_port_code,
                        data_type: this.state.data_type,
                        csvData: fileData,
                    }
                    console.log("reqParams", reqParams)
                    redirectURL.post("/lmconsignees/savebulknewlmloadshare", reqParams).then((response) => {
                        var resp = response.data.message;
                        console.log(resp)
                        this.setState({
                            basicTitle: resp,
                            basicType: "success",
                            show: true,
                            bulkslide: '',
                            overly: 'show-n',
                        })
                        window.location.reload();
                    }).catch((e) => {
                        console.log(e);
                    })
                }
                else {
                    this.setState({
                        basicTitle: "Invalid File",
                        basicType: "warning",
                        show: true,
                    })
                }
                $('#upform')[0].reset();
            }
            else {
                $("#bulkUploadID").val();
                this.setState({
                    basicTitle: "Fields Should not be Empty",
                    basicType: "warning",
                    show: true,
                })
                $('#upform')[0].reset();
            }
        }
    };

    onClickResetData = () => {
        console.log("clicked")
        var loading_port_code = this.state.loading_port_code;
        var reqParams = {
            loading_port_code: loading_port_code,
            data_type: this.state.data_type
        }
        redirectURL.post("/lmconsignees/resetLmLoadShare", reqParams).then((response) => {
            var resp = response.data.message;
            console.log(resp)
            this.setState({
                basicTitle: resp,
                basicType: "success",
                show: true,
                bulkslide: '',
                overly: 'show-n',
                loadshow: 'show-n',
            })
            var dataType = this.state.dataType;
            this.onLoadShowData();
        }).catch((e) => {
            console.log(e);
        })
    }

    syncData = () => {
        console.log("syncData")
        var loading_port_code = this.state.loading_port_code;
        var reqParams = {
            loading_port_code: loading_port_code,
            data_type: this.state.data_type
        }
        this.setState({
            overly: 'show-m',
            loadshow: 'show-m',
        });
        redirectURL.post("/lmconsignees/syncLmLoadShare", reqParams).then((response) => {
            var resp = response.data.message;
            console.log(resp)
            this.setState({
                basicTitle: resp,
                basicType: "success",
                show: true,
                bulkslide: '',
                overly: 'show-n',
                loadshow: 'show-n',
            })
            var dataType = this.state.dataType;
            //this.onLoadShowData();
            window.location.reload();
        }).catch((e) => {
            console.log(e);
        })
    }

    onSelectBulkPlants = (location) => {
        var plants = [];
        try {
            location.map(function (e) {
                plants.push(e.value);
            })
            console.log(plants);
            this.setState({
                plant_name: plants
            });
        }
        catch (e) {
            console.log(e);
        }

    }

    updateGridData() {
        console.log("hello")
        var allrows = []
        this.gridApi.forEachNode((node, index) => {
            //console.log("node ",node)
            allrows.push(node.data)
        })
        //console.log("allrows ", allrows)
        var records = []
        if (allrows.length > 0) {
            allrows.forEach((item) => {
                //console.log("item ", item)
                var row = {}
                row.transporter_code = item.transporter_code
                row.transporter_name = item.transporter_name
                var zones = []
                for (var x in item) {
                    //console.log("Item key ", x)
                    if (x == "transporter_name" || x == "zone" || x == "transporter_code" || x == "total") {

                    }
                    else {
                        zones.push({
                            "zone": x,
                            "sob": parseFloat(item[x])
                        })
                    }
                }
                row.zones = zones
                records.push(row)
            })
        }
        //console.log("records ",records)
        var loading_port_code = this.state.loading_port_code;
        var parameters = {
            records: records,
            loading_port_code: loading_port_code,
            data_type: this.state.data_type,
        }
        redirectURL.post("/lmconsignees/updatelmloadshare", parameters)
            .then((response) => {
                console.log(response);
                if (response.data.message == "success") {
                    this.setState({
                        basicTitle: "Updated Successfully.",
                        basicType: "success",
                        show: true
                    })
                    var dataType = this.state.dataType;
                    this.onLoadShowData();
                }
                else {
                    this.setState({
                        basicTitle: "Failed to update.",
                        basicType: "warning",
                        show: true
                    })
                }
            })
    }

    // processRunSob() ran SOB from this screen, the last hop of the old Truck Availability ->
    // Assign Transporters -> Load Share walk. Removed with its buttons (client, 2026-10-14); SOB
    // runs from the plan's SOB panel, which calls the same generateLoadBySOB route.

    async onClickTab(pageType) {
        if (pageType == "zonewise") {
            var zonewise = "activet";
            var statewise = "";
            var dataType = 0;
        }
        else if (pageType == "statewise") {
            var zonewise = "";
            var statewise = "activet";
            var dataType = 1;
        }
        console.log(dataType, "dataType")
        await this.setState({
            zonewise: zonewise,
            statewise: statewise,
            dataType: dataType
        })
        await this.onLoadShowData();

    }
    componentDidUpdate() {
        if (this.context && this.context.loading_port_code !== this._lastLoadingPortCode) {
            this._lastLoadingPortCode = this.context.loading_port_code;
            this.onGlobalPortChange(this.context.loading_port_code);
        }
    }
    onGlobalPortChange = async (selectedPlant) => {
        if (!selectedPlant) { return; }
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m',
        })
        await this.pageAccess();
    }
    async onClickDataTab(data_type, type) {
        var regularActive = "";
        var truckActive = "";
        var courierActive = "";
        var hubActive = "";
        var airCourierActive = "";
        if (data_type == 1 && type !== "hub") {
            regularActive = "activet";
        }
        else if (data_type == 2 && type !== "airCourier") {
            truckActive = "activet";
        }
        else if (data_type == 3) {
            courierActive = "activet";
        } else if (data_type == 1 && type === "hub") {
            hubActive = "activet";
        } else if (data_type == 2 && type === "airCourier") {
            airCourierActive = "activet";
        }
        await this.setState({
            data_type: data_type,
            regularActive: regularActive,
            truckActive: truckActive,
            courierActive: courierActive,
            hubActive: hubActive,
            airCourierActive: airCourierActive
        });
        if (type == "hub") {
            return
        }
        await this.onLoadShowData();
    }
    render() {

        var columnwithDefs = [
            {
                headerName: "Transporter",
                field: "transporter_name",
                width: 150,
                filter: true,
                resizable: true,
                editable: true,
                cellEditor: 'agSelectCellEditor',
                cellEditorParams: {
                    values: this.state.trnsportersList,
                },
            },

            {
                headerName: "State",
                field: "state",
                width: 290,
                filter: true,
                resizable: true,
                editable: true,
                cellEditor: 'agSelectCellEditor',
                cellEditorParams: {
                    values: this.state.statesList,
                },
            },
            {
                headerName: "Share Of Business",
                field: "sob",
                width: 100,
                filter: true,
                resizable: true,
                editable: true,
            },
            {
                pinned: "left",
                headerName: "Update",
                field: "_id",
                width: 150,
                resizable: true,
                editable: false,
                cellRendererSelector: function (params) {
                    var rendComponent = {
                        component: 'UpdateButton'
                    };
                    return rendComponent;
                },
            },
            {
                pinned: "left",
                headerName: "id",
                field: "id",
                width: 100,
                filter: true,
                resizable: true,
                editable: false,
            },
        ]
        var userroles = localStorage.getItem("roles")
        console.log(this.state.transactionId, this.state.transactionId != undefined, this.state.transactionId != "", "transactionId")
        return (
            <div class="container-fluid d-flex flex-column" style={{ height: "100%" }}>
                <SweetAlert
                    show={this.state.show}
                    type={this.state.basicType}
                    title={this.state.basicTitle}
                    onConfirm={this.closeAlert}
                >
                </SweetAlert>
                <SweetAlert
                    show={this.state.show1}
                    type={this.state.basicType1}
                    title={this.state.basicTitle1}
                    onConfirm={this.closeAlert1}
                >
                </SweetAlert>

                    <div className="row" style={{ marginBottom: "10px", flexShrink: 0 }}>
                        <div className="col-sm-12">
                            <ul
                                style={{
                                    display: "inline-flex",
                                    flexWrap: "wrap",
                                    padding: "4px",
                                    margin: 0,
                                    listStyle: "none",
                                    gap: "4px",
                                    backgroundColor: "#ffffff",
                                    borderRadius: "10px",
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.15)"
                                }}
                            >
                                {[
                                    { onClick: this.onClickDataTab.bind(this, 1, "hub"), label: "Hub", active: this.state.hubActive },
                                    { onClick: this.onClickDataTab.bind(this, 1, ""), label: "Regular", active: this.state.regularActive },
                                    ...((userroles.indexOf("lm_FullAccess") >= 0) ? [{ onClick: this.onClickDataTab.bind(this, 2, ""), label: "Surface Courier", active: this.state.truckActive }] : []),
                                    { onClick: this.onClickDataTab.bind(this, 2, "airCourier"), label: "Air Courier", active: this.state.airCourierActive },
                                    { onClick: this.onClickDataTab.bind(this, 3, ""), label: "Dedicated", active: this.state.courierActive },
                                ].map(({ onClick, label, active }, idx) => {
                                    var isActive = active == "activet";
                                    return (
                                        <li key={idx} onClick={onClick} style={{ listStyle: "none" }}>
                                            <button
                                                type="button"
                                                style={{
                                                    whiteSpace: "nowrap",
                                                    border: "none",
                                                    outline: "none",
                                                    borderRadius: "999px",
                                                    padding: "8px 18px",
                                                    fontSize: "13px",
                                                    fontWeight: isActive ? 600 : 500,
                                                    cursor: "pointer",
                                                    transition: "all 0.2s ease",
                                                    backgroundColor: isActive ? "#1976d2" : "transparent",
                                                    color: isActive ? "#fff" : "#555",
                                                    boxShadow: isActive ? "0 1px 4px rgba(25,118,210,0.4)" : "none"
                                                }}
                                            >
                                                {label}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>

                {this.state.hubActive == "activet" ?
                    // <div className="bg-primary" style={{ flexGrow: 1 }}>
                    <HubLoadSharePage />
                    // </div>
                    :
                    <>
                        <div className="card col-xl-12" style={{ borderRadius: "10px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)", flex: "1 1 0%", display: "flex", flexDirection: "column", minHeight: 0 }}>
                            <div className="card-header d-none">
                                <h5>
                                    <span>Load Share</span>
                                    {(this.state.pageAccess != 2) ?
                                        <button className="btn btn-warning" style={{ float: "right", marginRight: "10px" }} onClick={this.syncData.bind(this)}>Sync Data</button>
                                        : ""}
                                    {(this.state.pageAccess != 2) ?
                                        <button className="btn btn-info d-none" style={{ float: "right", marginRight: "10px" }} onClick={this.showBulkUpload.bind(this)}>Import Data</button>
                                        : ""}
                                    {/* {(this.state.pageAccess != 2) ?
                        <button className="btn btn-danger" style={{float:"right",marginRight:"10px"}} onClick={this.onClickResetData.bind(this)}>Reset</button>
                        : ""} */}
                                </h5>
                            </div>
                            <div className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap", gap: "10px", padding: "14px 18px", flexShrink: 0 }}>
                                <div className="d-flex align-items-center" style={{ gap: "14px" }}>
                                    <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                                    <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px" }}>Load Share</h5>
                                </div>

                                <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "8px" }}>
                                    <button
                                        className="pill-btn"
                                        style={{ backgroundColor: "#f57c00", color: "#fff" }}
                                        onClick={
                                            this.syncData.bind(this)
                                        }
                                    >
                                        Sync Data
                                    </button>
                                    {/* <button
                                        className="pill-btn pill-btn-info d-none"
                                        onClick={() => setShowBulkSlider(true)}
                                    >
                                        Import Data
                                    </button> */}
                                </div>
                            </div>

                            {/* <div className="d-flex justify-content-end align-items-end px-3" style={{ gap: "10px" }}>

                                {this.state.lpNames.length > 0 ? <div className="d-flex flex-column">
                                    {this.state.resetDate != "" ?
                                        <h6 style={{ float: "right" }}>Weekly SOB <span style={{ color: "red", fontWeight: "600", }}> Reset</span> on <span style={{ color: "green", fontWeight: "600" }}>{moment.parseZone(this.state.resetDate).format('DD-MMM-YYYY @ hh:mm A')}</span></h6>
                                        : ""}
                                    {this.state.generatedDate != "" ?
                                        <h6 style={{ float: "right" }}>Daily SOB <span style={{ color: "red", fontWeight: "600" }}>{(this.state.generatedType)}</span> synced on <span style={{ color: "green", fontWeight: "600" }}>{moment.parseZone(this.state.generatedDate).format('DD-MMM-YYYY @ hh:mm A')}</span></h6>
                                        : ""}
                                </div> :
                                    <div className="">
                                        {this.state.generatedDate != "" && this.state.generatedDate ?
                                            <h6 style={{ float: "right" }}>Data <span style={{ color: "red", fontWeight: "600" }}>{(this.state.generatedType)}</span> synced on <span style={{ color: "green", fontWeight: "600" }}>{moment.parseZone(this.state.generatedDate).format('DD-MMM-YYYY @ hh:mm A')}</span></h6>
                                            : ""}
                                    </div>}
                            </div> */}


                            <div className="col-xl-12 col-lg-12" style={{ flex: 1, width: "100%", display: "flex", flexDirection: "column", minHeight: 0, padding: "0px 15px" }}>
                                <div className="d-flex justify-content-between align-items-end" style={{ marginBottom: "10px", flexShrink: 0 }}>
                                    <ul
                                        style={{
                                            display: "inline-flex",
                                            flexWrap: "wrap",
                                            padding: "4px",
                                            margin: 0,
                                            listStyle: "none",
                                            gap: "4px",
                                            backgroundColor: "#f4f6f8",
                                            borderRadius: "10px"
                                        }}
                                    >
                                        {[
                                            { key: "zonewise", label: "Zone Wise SOB", active: this.state.zonewise },
                                            { key: "statewise", label: "State Wise SOB", active: this.state.statewise },
                                        ].map(({ key, label, active }) => {
                                            var isActive = active == "activet";
                                            return (
                                                <li key={key} onClick={this.onClickTab.bind(this, key)} style={{ listStyle: "none" }}>
                                                    <button
                                                        type="button"
                                                        style={{
                                                            whiteSpace: "nowrap",
                                                            border: "none",
                                                            outline: "none",
                                                            borderRadius: "999px",
                                                            padding: "8px 18px",
                                                            fontSize: "13px",
                                                            fontWeight: isActive ? 600 : 500,
                                                            cursor: "pointer",
                                                            transition: "all 0.2s ease",
                                                            backgroundColor: isActive ? "#1976d2" : "transparent",
                                                            color: isActive ? "#fff" : "#555",
                                                            boxShadow: isActive ? "0 1px 4px rgba(25,118,210,0.4)" : "none"
                                                        }}
                                                    >
                                                        {label}
                                                    </button>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                    {this.state.lpNames.length > 0 ? <div className="d-flex flex-column">
                                    {formatSobStamp(this.state.resetDate) != "" ?
                                        <h6 style={{ float: "right" }}>Weekly SOB <span style={{ color: "red", fontWeight: "600", }}> Reset</span> on <span style={{ color: "green", fontWeight: "600" }}>{formatSobStamp(this.state.resetDate)}</span></h6>
                                        : ""}
                                    {formatSobStamp(this.state.generatedDate, true) != "" ?
                                        <h6 style={{ float: "right" }}>Daily SOB <span style={{ color: "red", fontWeight: "600" }}>{(this.state.generatedType)}</span> synced on <span style={{ color: "green", fontWeight: "600" }}>{formatSobStamp(this.state.generatedDate, true)}</span></h6>
                                        : ""}
                                </div> :
                                    <div className="">
                                        {formatSobStamp(this.state.generatedDate, true) != "" ?
                                            <h6 style={{ float: "right" }}>Data <span style={{ color: "red", fontWeight: "600" }}>{(this.state.generatedType)}</span> synced on <span style={{ color: "green", fontWeight: "600" }}>{formatSobStamp(this.state.generatedDate, true)}</span></h6>
                                            : ""}
                                    </div>}
                                </div>
                                {/* <div id="myGrid" style={{ width: "100%", height: "500px" }} className={"ag-theme-balham d-none" + this.state.showGridData}>
                                    <AgGridReact
                                        modules={this.state.modules}
                                        columnDefs={this.state.columnwithDefs}
                                        defaultColDef={this.state.defaultColDef}
                                        rowData={this.state.rowData}
                                        enableCharts={false}
                                        // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                        onGridReady={this.onGridReady}
                                        onGridState={this.onGridState}
                                        frameworkComponents={this.state.frameworkComponents}
                                        statusBar={this.state.statusBar}
                                        sideBar={this.state.sideBar}
                                        stopEditingWhenGridLosesFocus={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        pagination={false}
                                        pinnedBottomRowData={this.state.pinnedRegionBottomRowData}
                                        gridOptions={{
                                            context: { componentParent: this },
                                            getRowStyle: function (params) {
                                                if (params.node.rowPinned) {
                                                    return { 'font-weight': 'bold', 'font-size': '16px' };
                                                }
                                            },
                                        }}
                                        // components={this.state.components}
                                        enableRangeSelection={true}
                                        onCellClicked={this.onCellClicked.bind(this)}
                                    //onCellEditingStopped={this.onCellUpdateData.bind(this)}
                                    />
                                </div> */}
                                <div className="ag-theme-balham grid-wrapper mb-3" style={{ flex: 1, minHeight: 0 }}>
                                    <AgGridReact
                                        // ref={this.gridRef}
                                        modules={this.state.modules}
                                        rowData={this.state.rowData}
                                        columnDefs={this.state.columnwithDefs}
                                        defaultColDef={{
                                            sortable: true,
                                            filter: true,
                                            floatingFilter: true
                                        }}

                                        statusBar={{
                                            statusPanels: [
                                                { statusPanel: "agSelectedRowCountComponent", align: "left" },
                                                { statusPanel: "agFilteredRowCountComponent", align: "center" },
                                                { statusPanel: "agTotalRowCountComponent", align: "right" }
                                            ]
                                        }}
                                        sideBar={{
                                            toolPanels: [
                                                {
                                                    id: 'columns',
                                                    labelDefault: 'Columns',
                                                    iconKey: 'columns',
                                                    toolPanel: 'agColumnsToolPanel'
                                                },
                                                {
                                                    id: 'filters',
                                                    labelDefault: 'Filters',
                                                    iconKey: 'filter',
                                                    toolPanel: 'agFiltersToolPanel'
                                                }
                                            ],
                                            // defaultToolPanel: 'filters'
                                        }}
                                        animateRows rowSelection={"multiple"}
                                        rowHeight={45}
                                        headerHeight={45}
                                        frameworkComponents={this.state.frameworkComponents}
                                        onSelectionChanged={() => {
                                            // if (this.gridRef && this.gridRef.current && this.gridRef.current.api) {
                                            //     const selected = this.gridRef.current.api.getSelectedRows();
                                            //     this.setState({ selectedRows: selected })
                                            // }
                                        }} suppressRowClickSelection={true}
                                        pinnedBottomRowData={this.state.pinnedRegionBottomRowData || []}
                                    />
                                </div>
                                {(this.state.dataType == 1 && this.state.pageAccess != 2) ?
                                    <div className="d-flex justify-content-end" style={{ marginBottom: "12px", flexShrink: 0 }}>
                                        <button type="button" onClick={this.updateGridData.bind(this)} className="pill-btn" style={{ backgroundColor: "#f57c00", color: "#fff" }}>Assign</button>
                                    </div>
                                    : ""}
                            </div>
                        </div>


                        {/* <button className="btn btn-success" onClick={this.formAssignHandler.bind(this)} style={{marginLeft:"91em"}}>Insert Exports</button> */}
                        <div className={"slide-r " + (this.state.bulkslide)} style={{ overflow: "hidden" }}>
                            <h3 className="subH">Bulk Upload</h3>
                            <div className="slide-r-body" style={{ position: "relative" }}>
                                {(this.state.sliderType == 2) ?
                                    <div className="container-fluid">
                                        <div className="row">
                                            <table className="table">
                                                <tbody>
                                                    {this.state.zoneStates.map(function (zs) {
                                                        return <tr>
                                                            <td style={{ padding: "5px", border: "none" }}>{zs.state}</td>
                                                        </tr>
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    :
                                    <div className="container-fluid">
                                        <form method="POST" id="upform" className="theme-form" onSubmit={this.uploadBulkFormHandler}>

                                            <div className="form-group mt-20p">
                                                <label className="">Upload File</label>
                                                <input type="file" name="uploadFile" id="bulkUploadID" onChange={this.changeFileHandler} className="form-control" required />
                                            </div>
                                            <div className="form-group">
                                                <button type="submit" className="pill-btn pill-btn-success">Submit</button>
                                                <button type="button" onClick={this.resetUpload.bind(this)} className="pill-btn ml-2" style={{ backgroundColor: "#eceff1", color: "#455a64" }}>Cancel</button>
                                            </div>
                                        </form>
                                        <div className="form-group">
                                            <a className="pill-btn pill-btn-primary" href={require('../../assets/json/sample_lmloadshare.csv')} target="_blank">Sample Template</a>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className={"dataLoadpage " + (this.state.loadshow)}>
                        </div>
                        <div className={"dataLoadpageimg " + (this.state.loadshow)}>
                            <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                        </div>
                        <div className={"overlay-part " + (this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
                    </>}
            </div>

        );
    }
}

function dateComparator1(date1, date2) {
    //console.log(date1,date2);
    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
        // console.log(date1,date2);
        var date_1 = getMonthNumber(date1.split("-")[1]);
        date1 = date1.replace(date1.split("-")[1], date_1);
        var date_2 = getMonthNumber(date2.split("-")[1]);
        date2 = date2.replace(date2.split("-")[1], date_2);
        var date1Number = monthToComparableNumber1(date1);
        var date2Number = monthToComparableNumber1(date2);
        if (date1Number === null && date2Number === null) {
            return 0;
        }
        if (date1Number === null) {
            return -1;
        }
        if (date2Number === null) {
            return 1;
        }
        return date1Number - date2Number;
    }
}

function monthToComparableNumber1(date) {
    console.log(date.length);
    console.log(date);
    if (date === undefined || date === null || date.length !== 10) {
        return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
}
function dateComparator(date1, date2) {
    // console.log("dateComparator");
    // console.log(date1.length);
    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
        // console.log(date1,date2);
        var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
        date1 = date1.replace(date1.split(" ")[0].split("-")[1], date_1);
        var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
        date2 = date2.replace(date2.split(" ")[0].split("-")[1], date_2);
        // console.log(date1,date2);
        var date1Number = monthToComparableNumber(date1);
        var date2Number = monthToComparableNumber(date2);
        // console.log(date1Number,date2Number);
        if (date1Number === null && date2Number === null) {
            return 0;
        }
        if (date1Number === null) {
            return -1;
        }
        if (date2Number === null) {
            return 1;
        }
        return date1Number - date2Number;
    }
}
function monthToComparableNumber(date) {
    // console.log(date,date.length);
    if (date === undefined || date === null || date.length !== 16) {
        return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    console.log(yearNumber, monthNumber, dayNumber);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
}

function getMonthNumber(monthName) {
    var months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May',
        'Jun', 'Jul', 'Aug', 'Sep',
        'Oct', 'Nov', 'Dec'
    ];
    var monthNum = months.indexOf(monthName) + 1;
    if (monthNum < 10) {
        monthNum = "0" + monthNum.toString();
    }
    return monthNum;
}


function loadDateTimeScript() {
    // alert("timeDate");
    $('.datetimepicker_mask').datetimepicker({
        //mask:'39-19-9999 29:59',
        format: 'd-m-Y'
    });
    $('.datetimepicker_date').datetimepicker({
        mask: '39-19-9999',
        format: 'd-m-Y',
        timepicker: false
    });
    var index = window.document.getElementsByTagName("script")[1]
    var script = window.document.createElement("script")
    script.src = "https://www.jqueryscript.net/demo/Clean-jQuery-Date-Time-Picker-Plugin-datetimepicker/jquery.datetimepicker.js"
    //script.src="http://xdsoft.net/jqplugins/datetimepicker/"
    script.async = true
    script.defer = true
    index.parentNode.insertBefore(script, index)
}

function DateEditor() { }

// gets called once before the renderer is used
DateEditor.prototype.init = function (params) {
    // create the cell
    this.eInput = document.createElement('input');
    this.eInput.value = params.value;

    // https://jqueryui.com/datepicker/
    $(this.eInput).datetimepicker({
        dateFormat: "yy-mm-dd",
        changeMonth: true,
        changeYear: true,
        timepicker: false,
    });
};

// gets called once when grid ready to insert the element
DateEditor.prototype.getGui = function () {
    return this.eInput;
};

// focus and select can be done after the gui is attached
DateEditor.prototype.afterGuiAttached = function () {
    this.eInput.focus();
    this.eInput.select();
};

// returns the new value after editing
DateEditor.prototype.getValue = function () {
    // console.log(this.eInput.value);
    return this.eInput.value;
};

// any cleanup we need to be done here
DateEditor.prototype.destroy = function () {
    // but this example is simple, no cleanup, we could
    // even leave this method out as it's optional
};

// if true, then this editor will appear in a popup
DateEditor.prototype.isPopup = function () {
    // and we could leave this method out also, false is the default
    return false;
};
function groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}
const HubLoadSharePage = () => {
    // const location = useLocation();
    const gridRef = useRef();
    const portContext = useContext(LoadingPortContext);
    const lastPortRef = useRef(portContext.loading_port_code);

    const modules = [
        ClientSideRowModelModule,
        RowGroupingModule,
        MenuModule
    ];

    // ---------------- SLIDER STATE ----------------
    const [showSlider, setShowSlider] = useState(false);
    const [editHubSOB, setEditHubSOB] = useState({ open: false });


    // ---------------- FORM ----------------
    const [formData, setFormData] = useState({
        loading_port_code: null,
        hub_name: "",
        latitude: "",
        longitude: ""
    });

    const [rowData, setRowData] = useState(
    );
    const [editIndex, setEditIndex] = useState(null);
    const [loadingPortData, setLoadingPortData] = useState([])
    const [showBulkSlider, setShowBulkSlider] = useState(false);
    const [bulkFile, setBulkFile] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    console.log(loadingPortData, editIndex)

    const [loadshow, setLoadshow] = useState("show-n")
    const [overly, setOverly] = useState("show-n")
    const [pageAccess, setPageAccess] = useState(0);
    const [loadingPortCode, setLoadingPortCode] = useState("");
    const [compCode, setCompCode] = useState("");
    const [lpNames, setLpNames] = useState([]);
    const [errors, setErrors] = useState([]);
    const [validData, setValidData] = useState([]);
    const [fileName, setFileName] = useState("");
    const [transporterData, setTransporterData] = useState([]);
    const [hubCityData, setHubCityData] = useState([]);
    const [columnDefs, setColumnDefs] = useState([]);
    const [timeData, setTimeData] = useState({ resetDate: "", generatedDate: "", generatedType: "" });
    const [controller, setController] = useState({ open: false });
    const [hubSOBData, setHubSOBData] = useState([]);
    const [calculatedData, setCalculatedData] = useState([]);

    const [totalRowData, setTotalRowData] = useState([]);
    const [cityList, setCityList] = useState([])
    const fileInputRef = useRef(null);

    const [overErrors, setOverErrors] = useState([])

    const closeSlider = () => {
        setShowSlider(false);
        setEditIndex(null);
        setFormData({
            loading_port_code: null,
            hub_name: "",
            latitude: "",
            longitude: ""
        });
    };


    // const ActionRenderer = (props) => (
    //     <div className="d-flex justify-content-center align-items-center" style={{ gap: '6px', justifyContent: "center", width: "100%", height: "35px" }}>

    //         <Edit className="text-primary cursor-pointer ml-2"
    //             size={15} style={{ cursor: "pointer" }} onClick={() => { handleEdit(props) }} />
    //         <Trash className="text-danger cursor-pointer ml-2"
    //             size={15} style={{ cursor: "pointer" }} onClick={() => { handleDelete(props) }} />
    //     </div>
    // );
    // ---------------- GRID ----------------
    const components = {
        // actionRenderer: ActionRenderer
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoadshow("show-m")
            setOverly("show-m")
            var code = await pageAccessFn();
            await getLoadingPortCodeData();
            var transporter = await getTransportersData(code);
            var hubCity = await getHubCityData(code);
            var sobData = await getHubSOBData(code);
            createColumnDefs(transporter, hubCity);
            createRows(transporter, hubCity, sobData);
            setLoadshow("show-n")
            setOverly("show-n")
        }
        fetchData();
    }, []);

    const pageAccessFn = async () => {

        setLoadshow("show-m");
        setOverly("show-m");

        const currentUrl = window.location.pathname;
        var resolved = await resolvePageAccess(currentUrl, portContext);
        if (!resolved) {
            setLoadshow("show-n");
            setOverly("show-n");
            return;
        }
        setPageAccess(resolved.pageAccess);
        setLoadingPortCode(resolved.loading_port_code);
        setCompCode(resolved.comp_code);
        setLoadingPortData(resolved.lpNames);
        return resolved.loading_port_code;
    };

    const getHubSOBData = async (port, date) => {
        try {
            var params = {
                loading_port_code: port || loadingPortCode,
                data_type: 1, is_hub: 1
                // filter_start_date: date ? date : timeData.from_date, is_hub: 1
            }
            const response = await redirectURL.post("/lmconsignees/getHubLoadShare", params);
            console.log(response);
            if (response.status == "200") {
                setHubSOBData(response.data || [])
                var generatedDate = "";
                var generatedType = "";
                var resetDate = "";
                if (response.data.length > 0) {
                    // keep "" rather than undefined - see formatSobStamp
                    resetDate = response.data[0].last_reset_on || "";
                    generatedDate = response.data[0].created_date || "";
                    generatedType = response.data[0].generated_type;
                    // console.log(resetDate, generatedDate, "dates")
                    setTimeData((prevState) => ({ ...prevState, resetDate, generatedDate, generatedType }))
                }
                createRows(transporterData, hubCityData, response.data);
                return response.data.sobData
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const getTransportersData = async (port) => {
        try {
            var params = {
                loading_port_code: port || loadingPortCode,
                data_type: 1, hub_transporter: 1,
                status: 1
            }
            const response = await redirectURL.post("/lmconsignees/prtUniqueTransportersListWithNames", params);
            if (response.status == "200") {
                setTransporterData(response.data.filter((each) => each.transporter_code) || [])
                return response.data.filter((each) => each.transporter_code)
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const getHubCityData = async (port) => {
        try {
            var params = {
                loading_port_code: port || loadingPortCode,
                is_active: 1
            }
            const response = await redirectURL.post("/masters/getHubConsigneeCity", params);
            if (response.data.status == "success") {
                setHubCityData(response.data.hubMappingData || [])
                return response.data.hubMappingData || []
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const getLoadingPortCodeData = async () => {
        try {
            var params = {

            }
            const response = await redirectURL.post("/lmconsignees/getLmLoadingPorts", params);
            // console.log(response)
            if (response.status == "200") {
                // console.log(response)
                setLoadingPortData(
                    response.data
                        ? response.data.map((each) => ({
                            ...each,
                            label: each.comp_short_name,
                            value: each.loading_port_code
                        }))
                        : []
                );
                setLoadingPortCode(response.data[0].loading_port_code || "")
                return response.data[0].loading_port_code
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const createColumnDefs = (tArray, hArray) => {
        const uniqueHubs = [...new Set(hArray.map(e => e.hub_name))];

        const columnDefs = [
            { headerName: "Transporter Name", field: "transporter_name", width: 250 },
            { headerName: "Transporter Code", field: "transporter_code", width: 190 },

            ...uniqueHubs.map((hub) => ({
                headerName: `${hub} (Load)`,
                field: hub,
                width: 190,
                cellRendererFramework: (params) => {
                    if (Array.isArray(params.value) && params.value.length > 0) {
                        return (
                            <>
                                <span
                                    style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                                    onClick={() => handleViewCities(hArray, params.colDef.headerName)}
                                >
                                    {params.value[0]}
                                </span>
                                <span className="ml-3"
                                    style={{ color: "green", cursor: "pointer", textDecoration: "underline" }}
                                    onClick={() => handleEditHubSOB(params.colDef.headerName)}
                                >
                                    {params.value[1]}
                                </span>
                            </>
                        );
                    }
                    return params.value;
                }

            }))
        ];
        setColumnDefs(columnDefs);
    };
    var totalDataRef = useRef([]);
    const createRows = (transporters, hubCity, transdata) => {
        let rowdefs = [];
        const uniqueHubs = [...new Set(hubCity.map(e => e.hub_name))];
        transporters.forEach((ste) => {
            let rows = {
                transporter_name: ste.transporter_name,
                transporter_code: ste.transporter_code
            };

            // initialize all hubs with 0
            uniqueHubs.forEach((hub) => {
                rows[hub] = 0;
            });

            // fill actual data
            (transdata || []).forEach((t) => {
                if (t.transporter_code === ste.transporter_code) {
                    rows[t.zone] = parseFloat(t.load) || 0;
                }
            });

            rowdefs.push(rows);
        });

        // 🔹 Total Row
        let totalRow = {
            transporter_name: "",
            transporter_code: "Total (Load)"
        };

        uniqueHubs.forEach((hub) => {
            totalRow[hub] = 0;
        });

        rowdefs.forEach((row) => {
            uniqueHubs.forEach((hub) => {
                totalRow[hub] += parseFloat(row[hub]) || 0;
            });
        });

        // 🔹 View Row
        // let hubDetails = {
        //     transporter_name: "",
        //     transporter_code: ""
        // };

        // uniqueHubs.forEach((hub) => {
        //     hubDetails[hub] = ["View Cities", "Edit"];
        // });
        setCalculatedData([...rowdefs])
        setTotalRowData([totalRow])
        totalDataRef.current = [...rowdefs];

    };
    const handleViewCities = (hArray, hub) => {
        setCityList([hub, ... new Set(hArray.filter((each) => each.hub_name == hub).map((each) => each.consignee_city))]);
        setShowSlider(true);
    }
    const handleEditHubSOB = (hub) => {
        console.log(totalDataRef.current, hub)
        setEditHubSOB({
            open: true,
            hub: hub,
            data: totalDataRef.current,
            total: totalDataRef.current.reduce((sum, row) => sum + (Number(row[hub]) || 0), 0)
        })
    }
    const updateHubSOBData = async (data) => {
        try {
            var params = {
                loading_port_code: loadingPortCode,
                data_type: 1, is_hub: 1,
                data: data
            }
            console.log(params)
            const response = await redirectURL.post("/lmconsignees/saveBulkLmHubLoadShare", params);
            if (response.data.status == "success") {
                // setRowData(response.data.hubData || [])
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleBulkUpload = async () => {

        try {
            setLoadshow("show-m")
            setOverly("show-m")
            const finalData = validData
            // .map((each) => {
            //     return (
            //         {
            //             ...each,
            //             loading_port_code: loadingPortCode,
            //             comp_short_name: loadingPortData.find((each) => each.value == loadingPortCode).label || "",
            //             is_active: 1
            //         }
            //     )
            // })
            console.log(validData, finalData)

            await updateHubSOBData(finalData)
            await getHubSOBData();
            setLoadshow("show-n")
            setOverly("show-n")
            setValidData([])
            setTimeData((prevState) => ({ ...prevState, valid_from: "", valid_to: "" }))
            setFileName("")
            setErrors([])
            setOverErrors([])
            setShowBulkSlider(false);
            setBulkFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }


            // alert("Upload Successful");

        } catch (err) {
            console.error(err);
        }
    };

    const onClickHideAll = () => {
        // setLoadshow("show-n")
        // setOverly("show-n")

    }

    const customStyles = {
        control: (provided) => ({
            ...provided,
            cursor: editIndex !== null ? "not-allowed" : "pointer"
        }),
        valueContainer: (provided) => ({
            ...provided,
            cursor: editIndex !== null ? "not-allowed" : "pointer"
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            cursor: editIndex !== null ? "not-allowed" : "pointer"
        }),
        container: (provided) => ({
            ...provided,
            cursor: editIndex !== null ? "not-allowed" : "pointer",
            width: "100%"
        })
    }

    const handleFileChange = (e) => {

        const file = e.target.files[0];
        e.target.value = ""; // reset immediately

        if (!file) return;
        setFileName(file.name); // store file name

        const reader = new FileReader();
        reader.readAsArrayBuffer(file);

        reader.onload = (event) => {

            const workbook = XLSX.read(
                new Uint8Array(event.target.result),
                { type: "array" }
            );

            const sheet = workbook.Sheets[workbook.SheetNames[0]];

            const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });

            validateExcelData(data);
        };
    };


    const validateExcelData = (data) => {

        let validationErrors = [];
        let overPercentErrors = [];
        let cleanedData = [];

        let hubMap = {};

        data.forEach((row, index) => {

            const rowNumber = index + 2;

            let hubName = String(row["Hub"] || "").trim().toUpperCase();
            let transporterCode = row["Transporter Code"];
            // Hub ACTUAL load (CMT) - this page shows / feeds actual SOB, not the approved share.
            let approvedSOB = row["Load"] !== undefined && row["Load"] !== "" ? row["Load"]
                : (row["Load (CMT)"] !== undefined ? row["Load (CMT)"] : row["Load Share"]);

            let rowErrors = [];

            // ---- Transporter (by CODE only - the name comes from the master) ----
            const masterTransporter = findTransporterByCode(transporterData, transporterCode);
            if (!masterTransporter) {
                rowErrors.push(
                    `Transporter Code - "${transporterCode}" is not in transporter master for this warehouse`
                );
            }

            // ---- Hub ----
            if (!checkHubIdentity(hubName)) {
                rowErrors.push(`Hub - "${hubName}" does not exist in Hub Master`);
            }

            // ---- Load ----
            if (!isValidNumber(approvedSOB) || parseFloat(approvedSOB) < 0) {
                rowErrors.push(
                    `Load should be numeric and >= 0 (${approvedSOB})`
                );
            }

            // ---- Collect Errors or Valid Data ----
            if (rowErrors.length > 0) {
                validationErrors.push({
                    row: rowNumber,
                    errors: rowErrors
                });
            } else {

                const parsedSOB = parseFloat(approvedSOB);

                const cleanedRow = {
                    rowNumber,
                    transporter_name: masterTransporter.transporter_name,
                    transporter_code: masterTransporter.transporter_code,
                    zone: hubName,
                    load: parsedSOB
                };

                cleanedData.push(cleanedRow);

                if (!hubMap[hubName]) {
                    hubMap[hubName] = {
                        total: 0,
                        rows: []
                    };
                }

                hubMap[hubName].total += parsedSOB;
                hubMap[hubName].rows.push(cleanedRow);
            }
        });

        // ---- REMOVE INVALID ROWS SET ----
        const invalidRowNumbers = new Set(
            validationErrors.map((e) => e.row)
        );

        // ---- HUB LEVEL VALIDATION (ONE ERROR PER HUB) ----
        Object.keys(hubMap).forEach((hub) => {

            // Loads are volumes - no 100 cap (that rule belongs to the approved-share upload).
            if (false) {

                overPercentErrors.push({
                    hub: hub,
                    error: `Total Approved SOB for Hub "${hub}" exceeds 100 (Current Total: ${hubMap[hub].total})`
                });

                // mark rows invalid
                hubMap[hub].rows.forEach((row) => {
                    invalidRowNumbers.add(row.rowNumber);
                });
            }
        });

        // ---- FILTER VALID ROWS ----
        cleanedData = cleanedData.filter(
            (row) => !invalidRowNumbers.has(row.rowNumber)
        );

        // ---- FINAL DATA ----
        const finalData = cleanedData.map(({ rowNumber, ...rest }) => rest);

        setErrors(validationErrors);
        setOverErrors(overPercentErrors);
        setValidData(finalData);

        console.log("Validation Errors:", validationErrors);
        console.log("Over Percent Errors:", overPercentErrors);
        console.log("Valid Data:", finalData);
    };
    const checkHubIdentity = (name) => {
        const uniqueHubs = [...new Set(hubCityData.map(e => e.hub_name))];
        return uniqueHubs.includes(name);
    };

    const isValidNumber = (value) => {
        const str = String(value || "").trim();
        return str !== "" && /^\d+(\.\d+)?$/.test(str);
    };

    var errTrueUpload = errors.length > 0 && validData.length > 0
    var disableUpload = (validData.length == 0 || overErrors.length > 0)
    var disableUpdate = editHubSOB.total > 100;
    const getShortFileName = (name, maxLength = 31) => {
        const lastDot = name.lastIndexOf(".");
        const baseName = name.substring(0, lastDot);
        const extension = name.substring(lastDot);

        if (baseName.length <= maxLength) return name;

        return baseName.substring(0, maxLength) + "..." + extension;
    };

    const handlerTime = async (event, name, type) => {
        var d = new Date(event._d);

        var date = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + (d.getDate());

        // this.setState({
        //     valid_from: valid_from
        // });
        setTimeData((prevState) => ({
            ...prevState,
            [name]: date
        }))
        if (type) {
            await onClickSubmit(loadingPortCode, date);
        }
    }

    const addNewHubSOB = () => {
        // var cityArray = this.state.cityList.map((each) => ({ label: each.city, value: each.city, state: each.state }));
        // var stateArray = this.state.statesList.map((each) => ({ label: each, value: each }));
        // var vehicleCapacityArray = this.state.vehicleCap.map((each) => ({ label: each, value: each }));
        var transporterArray = transporterData.map((each) => ({ label: each.transporter_name, value: each.transporter_code }));
        const uniqueHubs = [...new Set(hubCityData.map(e => e.hub_name))];
        var clubbingResourceArray = [
            {
                id: 1,
                title: "Valid From",
                field: "valid_from",
                type: "date",
                inputData: { placeholder: "Select Date", name: "valid_from", dateFormat: "YYYY-MM-DD" },
                errMsg: "Please select the Valid From",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 2,
                title: "Valid To",
                field: "valid_to",
                type: "date",
                inputData: { placeholder: "Select Date", name: "valid_to", dateFormat: "YYYY-MM-DD" },
                errMsg: "Please select the Valid To",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 3,
                title: "Transporter",
                field: "transporter_code",
                type: "dropdown",
                optionsArray: transporterArray,
                errMsg: "Please Select Transporter.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            ...uniqueHubs.map((hub, index) => ({
                id: 4 + index,
                title: `${hub} SOB ( % )`,
                field: hub,
                type: "dropdown",
                optionsArray: transporterArray,
                errMsg: "Please Select Transporter.",
                is_active: true,
                is_disabled: false,
                is_required: true
            }))
        ];
        var titleLabel = "Add New Hub SOB"
        this.setState({
            controller: {
                open: true,
                title: titleLabel,
                btnType: "Add",
                formResourceArray: clubbingResourceArray,
                type: "add",
                formData: {}
            }
        })
    }
    const onClickSubmit = async (code, date) => {
        setLoadshow("show-m")
        setOverly("show-m")
        var transporter = await getTransportersData(code);
        var hubCity = await getHubCityData(code);
        var sobData = await getHubSOBData(code, date);
        createColumnDefs(transporter, hubCity);
        createRows(transporter, hubCity, sobData);
        setLoadshow("show-n")
        setOverly("show-n")
    }
    const onClickSync = async () => {
        try {
            setLoadshow("show-m")
            setOverly("show-m")
            var params = {
                loading_port_code: loadingPortCode,
                data_type: 1, is_hub: 1
            }
            console.log(params)
            const response = await redirectURL.post("/lmconsignees/syncLmLoadShare", params);
            if (response.data.status == "200") {
                // setRowData(response.data.hubData || [])
                setLoadshow("show-n")
                setOverly("show-n")
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (portContext.loading_port_code !== lastPortRef.current) {
            lastPortRef.current = portContext.loading_port_code;
            onGlobalPortChange(portContext.loading_port_code);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [portContext.loading_port_code]);

    const onGlobalPortChange = async (selectedPlant) => {
        if (!selectedPlant || !loadingPortData.some((each) => each.value == selectedPlant)) { return; }
        setLoadshow("show-m");
        setOverly("show-m");
        setLoadingPortCode(selectedPlant);
        await onClickSubmit(selectedPlant, timeData.from_date);
        setValidData([]);
        setErrors([]);
        setOverErrors([]);
        setShowBulkSlider(false);
        setBulkFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        setLoadshow("show-n");
        setOverly("show-n");
    };



    return (
        <div className="hub-master-container d-flex flex-column card col-xl-12" style={{ flex: "1 1 0%", minHeight: 0, margin: "0px", padding: "15px", overflowY: "auto" }}>

            {/* HEADER */}
            <div className="master-header">
                <div className="d-flex align-items-center" style={{ gap: "14px" }}>
                    <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                    <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px" }}>Load Share</h5>
                </div>

                <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                    <button
                        className="pill-btn"
                        style={{ backgroundColor: "#f57c00", color: "#fff" }}
                        onClick={() => {
                            onClickSync();
                        }}
                    >
                        Sync Data
                    </button>
                    <button
                        className="pill-btn pill-btn-info d-none"
                        onClick={() => {
                            setErrors([]);
                            setValidData([]);
                            setFileName("");
                            setShowBulkSlider(true);
                        }}
                    >
                        Import Data
                    </button>
                </div>
            </div>


            <div className="d-flex justify-content-between align-items-end px-3 mb-3" style={{ gap: "10px" }}>

                <div className="d-flex align-items-end flex-grow-1" style={{ gap: "10px" }}>
                    <div className="d-none" style={{ width: "190px" }}>
                        <p className="mb-1">Filter By Date:</p>
                        <div className="flex-grow-1">
                            <Datetime
                                value={timeData.from_date || ""}
                                disableCloseOnClickOutside={false}
                                closeOnSelect={true}
                                inputProps={{
                                    placeholder: 'Select Date',
                                    name: 'from_date',
                                    autoComplete: 'off'
                                }}
                                dateFormat="YYYY-MM-DD"
                                name="from_date"
                                onChange={async (e) => { await handlerTime(e, "from_date", true); }}
                            />
                        </div>
                    </div>
                </div>
                {loadingPortData.length > 1 ? <div className="d-flex flex-column">
                    {formatSobStamp(timeData.resetDate) != "" ?
                        <h6 style={{ float: "right" }}>Weekly SOB <span style={{ color: "red", fontWeight: "600", }}> Reset</span> on <span style={{ color: "green", fontWeight: "600" }}>{formatSobStamp(timeData.resetDate)}</span></h6>
                        : ""}
                    {formatSobStamp(timeData.generatedDate, true) != "" ?
                        <h6 style={{ float: "right" }}>Daily SOB <span style={{ color: "red", fontWeight: "600" }}>{(timeData.generatedType)}</span> synced on <span style={{ color: "green", fontWeight: "600" }}>{formatSobStamp(timeData.generatedDate, true)}</span></h6>
                        : ""}
                </div> :
                    <div className="">
                        {formatSobStamp(timeData.generatedDate, true) != "" && timeData.generatedType ?
                            <h6 style={{ float: "right" }}>Data <span style={{ color: "red", fontWeight: "600" }}>{(timeData.generatedType)}</span> synced on <span style={{ color: "green", fontWeight: "600" }}>{formatSobStamp(timeData.generatedDate, true)}</span></h6>
                            : ""}
                    </div>}
            </div>

            {/* GRID */}
            <div className="ag-theme-balham grid-wrapper mx-3 mb-2" style={{ flex: 1, minHeight: 0 }}>
                <AgGridReact
                    ref={gridRef}
                    modules={modules}
                    rowData={calculatedData}
                    columnDefs={columnDefs}
                    defaultColDef={{
                        sortable: true,
                        filter: true,
                        floatingFilter: true
                    }}
                    statusBar={{
                        statusPanels: [
                            { statusPanel: "agSelectedRowCountComponent", align: "left" },
                            { statusPanel: "agFilteredRowCountComponent", align: "right" },
                            { statusPanel: "agTotalRowCountComponent", align: "right" }
                        ]
                    }}
                    animateRows
                    rowHeight={45}
                    headerHeight={45}
                    frameworkComponents={components}
                    onSelectionChanged={() => {
                        if (gridRef && gridRef.current && gridRef.current.api) {
                            const selected = gridRef.current.api.getSelectedRows();
                            setSelectedRows(selected);
                        }
                    }}
                    pinnedBottomRowData={totalRowData || []}
                />
            </div>

            {/* OVERLAY */}
            {showSlider && (
                <div
                    className="slider-overlay"
                    onClick={closeSlider}
                />
            )}
            {showBulkSlider && (
                <div
                    className="slider-overlay"
                    onClick={() => {
                        setValidData([])
                        setTimeData((prevState) => ({ ...prevState, valid_from: "", valid_to: "" }))
                        setFileName("")
                        setErrors([])
                        setOverErrors([]);
                        setShowBulkSlider(false);
                        setBulkFile(null);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                    }}
                />
            )}
            {editHubSOB.open && (
                <div
                    className="slider-overlay"
                    onClick={() => {
                        setEditHubSOB({ open: false })
                    }}
                />
            )}

            {/* RIGHT SLIDER */}
            <div className={`hub-slider ${showSlider ? "open" : ""} d-flex flex-column`}>

                <div className="slider-header">
                    {`${cityList[0]} Hub Cities`}
                    <span onClick={closeSlider}>✕</span>
                </div>

                <div className="slider-body flex-grow-1 pt-4">
                    {cityList.slice(1,).map((each) => {
                        return <p className="font-bold" style={{ color: "#000", fontWeight: "bold" }}>{each}</p>
                    })}

                </div>
                <div className="slider-footer d-none">
                    <button
                        className="save-btn" style={{ margin: "0px" }}
                        onClick={""}
                    >
                        {editIndex !== null ? "Update" : "Save"}
                    </button>
                </div>
            </div>

            <div className={`hub-slider ${showBulkSlider ? "open" : ""} d-flex flex-column`}>

                <div className="slider-header">
                    Bulk Upload Hub
                    <span onClick={() => setShowBulkSlider(false)}>✕</span>
                </div>

                <div className="slider-body flex-grow-1">
                    <p className="mb-1" style={{ fontSize: "12px", color: "#555" }}>
                        Hub actual load: columns Transporter Code, Hub, Load (CMT).
                        The file replaces the current hub load share of this warehouse.
                    </p>
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept=".xlsx,.xls,.csv"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                    />
                    {/* Upload button */}
                    <div className="d-flex align-items-center gap-3 mt-3">
                        <button
                            className="btn btn-info d-flex justify-content-center p-3"
                            type="button"
                            onClick={() => fileInputRef.current.click()}
                        >
                            Upload File
                        </button>

                        <button type="button" className="btn btn-secondary d-flex justify-content-center ml-3 p-3 flex-grow-1"
                            onClick={() => {
                                const ws = XLSX.utils.aoa_to_sheet([["Transporter Code", "Hub", "Load"]]);
                                const wb = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(wb, ws, "Hub Load Share");
                                XLSX.writeFile(wb, "hub_load_share_template.xlsx");
                            }}>
                            Download Sample Template
                        </button>
                    </div>

                    {fileName && (
                        <div style={{ marginTop: "15px", display: "flex", gap: "6px", maxWidth: "410px" }}>
                            <span>Selected File :</span>
                            <span
                                style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    flex: 1,
                                    fontWeight: "bold"
                                }}
                                title={fileName}
                            >
                                {getShortFileName(fileName)}
                            </span>
                        </div>
                    )}

                    {overErrors.length > 0 && <div>
                        <p className="text-danger" style={{ fontSize: "15px", fontWeight: "bold", color: "#000" }}>Hub Over Percentage Errors</p>
                        {overErrors.map((err, i) => (
                            <div key={i} style={{ color: "#000" }}>
                                <b>{err.hub}:</b> {err.error}
                            </div>
                        ))}
                    </div>}

                    {errors.length > 0 && (
                        <>
                            <h6 className="text-danger mt-3">Validation Errors</h6>

                            <div className="" style={{ width: "100%" }}>
                                <table className="table-bordered mb-0 err-table" style={{ width: "100%", positive: "relative", height: "100%" }}>
                                    <thead className="table-light text-center"
                                    // style={{ positive: "sticky", zIndex: "100", backgroundColor: "#efefef" }}
                                    >
                                        <tr>
                                            <th style={{ width: "60px", padding: "9px 15px" }}>Row</th>
                                            <th>Error Description</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {errors.map((err, i) => (
                                            <tr key={i}>
                                                <td className="text-center" style={{ padding: "9px 15px" }}>
                                                    {err.row}
                                                </td>

                                                <td style={{ padding: "9px 15px", wordBreak: "break-word" }}>
                                                    {err.errors.map((e, idx) => (
                                                        <p className="m-0" key={idx}>{e}</p>
                                                    ))}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}

                </div>
                <div className="slider-footer">
                    <button
                        className="save-btn" style={{ margin: "0px", width: "auto", padding: "5px 25px", cursor: disableUpload && "not-allowed", opacity: disableUpload && "0.5" }}
                        onClick={handleBulkUpload}
                        disabled={disableUpload}
                    >
                        {errTrueUpload ? "Upload only valid data" : "Upload"}
                    </button>
                </div>

            </div>

            <div className={`hub-slider ${editHubSOB.open ? "open" : ""} d-flex flex-column`} style={{ width: "590px", right: !editHubSOB.open && "-590px" }}>

                <div className="slider-header">
                    {`${editHubSOB.hub}`}
                    <span onClick={closeSlider}>✕</span>
                </div>

                <div
                    className="flex-grow-1"
                    style={{ overflowY: "auto" }}
                >
                    {editHubSOB.total > 100 && (
                        <p className="m-0 px-3 pt-3" style={{ color: "red", marginTop: "8px", backgroundColor: "#fff", position: "sticky", top: 0, zIndex: 1, left: 0 }}>
                            ⚠️ Total SOB must not be greater than 100%
                        </p>
                    )}
                    <div style={{ width: "100%", height: "100%" }} className="p-3 d-flex flex-column">
                        <table className="htu"
                            style={{
                                width: "100%",
                            }}
                        >
                            <thead>
                                <tr className="">
                                    <th style={{}}>
                                        Transporter Name
                                    </th>
                                    <th style={{}}>
                                        Transporter Code
                                    </th>
                                    <th style={{}}>
                                        {editHubSOB.hub}
                                    </th>
                                </tr>
                            </thead>

                            <tbody style={{ height: "250px", overflowY: "auto" }}>
                                {(editHubSOB.data || []).map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.transporter_name}</td>
                                        <td>{row.transporter_code}</td>
                                        <td className="d-flex justify-content-center">
                                            <input
                                                type="text"
                                                className="form-default"
                                                value={row[editHubSOB.hub] || ""}
                                                style={{ width: "100px", color: "blue" }}
                                                onChange={(e) => {
                                                    let value = e.target.value;

                                                    // ✅ Allow empty OR positive float
                                                    if (value === "" || /^\d*\.?\d*$/.test(value)) {

                                                        // ❌ prevent multiple dots like 1.2.3
                                                        if ((value.match(/\./g) || []).length > 1) return;

                                                        let updated = [...editHubSOB.data];
                                                        updated[index][editHubSOB.hub] = value;

                                                        // ✅ calculate total
                                                        let total = updated.reduce(
                                                            (sum, row) => sum + (parseFloat(row[editHubSOB.hub]) || 0),
                                                            0
                                                        );

                                                        setEditHubSOB(prev => ({
                                                            ...prev,
                                                            data: updated,
                                                            total
                                                        }));
                                                    }
                                                }}
                                                placeholder="0"
                                                // 🔥 Block invalid key presses
                                                onKeyDown={(e) => {
                                                    if (["-", "e", "E", "+"].includes(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}

                                                // 🔥 Prevent invalid paste
                                                onPaste={(e) => {
                                                    const paste = e.clipboardData.getData("text");
                                                    if (!/^\d*\.?\d*$/.test(paste)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>

                            <tfoot>
                                <tr style={{

                                    zIndex: 2
                                }}>
                                    <td colSpan="2" className="text-center py-2"><b>Total</b></td>
                                    <td
                                        style={{

                                            zIndex: 2
                                        }} className="text-center py-2"
                                    >
                                        <b style={{ color: editHubSOB.total > 100 ? "red" : "green" }}>{editHubSOB.total} %</b>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <div className="slider-footer">
                    <button
                        className="save-btn" style={{ margin: "0px", cursor: disableUpdate && "not-allowed", opacity: disableUpdate && "0.5" }}
                        onClick={""}
                        disabled={disableUpdate}
                    >
                        {"Update"}
                    </button>
                </div>
            </div>

            {/* {controller.open && (
                <>
                    <div
                        className="slider-overlay"
                        onClick={() => { setController((prevState) => ({ ...prevState, open: false })) }}
                    />
                    <AddEditController
                        resource={controller}
                        onUpdate={onUpdateHubSOB}
                    />
                </>
            )} */}

            <div className={"dataLoadpageimg " + (loadshow)}>
                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
            </div>
            <div className={"overlay-part " + (overly)} onClick={onClickHideAll}></div>


        </div>
    );

};